<template>
    <templateList
        page-name="Lista de Propostas"
        search-event="sales-proposals-search"
        add-event="sales-proposals-add"
        :add-button-text="proposalButtonNameComputed"
        filters-apply-event="filter-list-proposals"
        clear-filters-event="clear-filters-list-proposals"
        search-input-placeholder="Buscar cliente"
        menu-card-icon="fal fa-cog"
        @input='loadFilters'
    >

        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left>
                    Vendas &#8226; Propostas
                </template>
            </ui-breadcrumbs>
        </template>

        <template #content>
            <ui-data-table
                :per-page="50"
                :columns="tableColumnsComputed"
                :filters="tableFiltersComputed"
                :sort-by="{ value: 'updated_at', dir: 'desc' }"
                :control-fixed="true"
                :borders="true"
                name="proposalsList"
                service="proposal"
                search-event="sales-proposals-search"
                tr-component="sales/proposal/table-line"
                not-found-icon="fal fa-user"
                not-found-text="Não foi possível encontrar nenhuma Proposta"
                :is-fixed-list="true" />
			
            <ui-broker-modal name="sales-proposals-select-broker" />
            <ui-procedure-modal name="proposal-multiple-precedure" success-event="sales-proposals-search"  />

            <ui-deal-stage-status-modal name="sales-proposals-select-stage-status" />
        </template>

        <template #filters>
            <form>
                <template
                    v-for="(filter, index) in filtersComputed"
                >
                    <ui-date-range 
                        v-if="filter.component === 'datepicker-range' && !filter.disabled"
                        :key="index" 
                        v-model="filter.params.value"
                        size="md"
                        :label="filter.label"
                    />

                    <ui-select-2
                        v-else-if="filter.component === 'select-tags' && !filter.disabled"
                        :key="index"
                        v-model="filter.params.value"
                        :data="filter.options"
                        :label="filter.label"
                        :item-label="filter.itemLabel"
                        :search="filter.searchAble"
                        :multiple="filter.multiple"
                        :return-value="filter.returnValue || 'object'"
                        :group-by="filter.groupBy || ''"
                        :loading="filter.loading"
                        :open-event="filter.openEvent"
                        size="md"
                        @input="call(filter.handler, $event)"
                    />    
                </template>    
				
            </form>
        </template>
    </templateList>
</template>

<script>
	import { uiBreadcrumbs, uiDataTable } from "@/components/ui"
	import { uiDateRange, uiSelect2 } from "@/components/ui/form"
    import { uiBrokerModal, uiDealStageStatusModal } from '@/components/ui-facilita/modals'

    import uiProcedureModal from '@/components/ui-facilita/sales/procedure-modal'

	import templateList from "@/templates/page-list"

	import { funnel, team, configuration } from '@/services/axios'
	import { storage } from '@/services/storage'

	import helpers from '@/mixins/helpers'

	import { mapGetters } from 'vuex'

	import { filters, columns } from './data'


	export default {
		name: 'ui-proposal-list',
		components: {
			templateList,
			uiBreadcrumbs,
			uiDataTable,
			uiDateRange,
			uiBrokerModal,
			uiDealStageStatusModal,
			uiProcedureModal,
			uiSelect2
		},
		
		mixins: [helpers],

		data() {
			return {
				layout: {
					showFiltersMenu: false,
				},
				configurations: {
					proposal: {
						stage: 0,
						status: []
					},
					groups: {
						manager: storage.get('label_manager'),
						broker: storage.get('label_broker')
					}
				},
				filters: [...filters],
				tableColumns: [...columns],
				
			}
			
		},

		computed: {
			...mapGetters('auth', {
				user: 'getUser'
			}),

			/**
				* Filtra e processa os filtros disponíveis de acordo com regras específicas para cada filtro
				*/
			filtersComputed() {
				return this.filters.map(filter => {
					switch (filter.params.name) {
						case 'team_id':
							/**
								* Caso o usuário logado seja do tipo gerente ou corretor, seleciona a equipe deste
								* e desabilita o filtro de equipes
								*/
							if (['manager', 'broker'].includes(this.user.user_group)) {
								filter.params.value = this.user.team ? this.user.team.id : null
								filter.disabled = true
								filter.hidden = true
							}
							break

						case 'manager_id':
							filter.label = this.configurations.groups.manager

							/**
								* Caso o usuário logado seja do tipo gerente ou corretor, carrega o manager_id deste
								* e desabilita o filtro de gerentes
								*/
							if (['manager', 'broker'].includes(this.user.user_group)) {
								if (this.user.user_group === 'manager') {
									filter.params.value = this.user.manager_id || null

								} else if (this.user.user_group === 'broker') {
									filter.params.value = this.user.manager ? this.user.manager.manager_id : null
								}

								filter.disabled = true
								filter.hidden = true
							}
							break

						case 'broker_id':
							filter.label = this.configurations.groups.broker

							if (this.user.user_group === 'broker') {
								filter.params.value = this.user.broker_id || null
								filter.disabled = true
								filter.hidden = true
							}
							break
						
						case 'funnel_stage_status_id':
							/** Carrega as opções do filtro de status de acordo com as configurações de formulário */
							if (this.configurations.proposal && this.configurations.proposal.status) {
								filter.options = Object.values(this.configurations.proposal.status)
									.map(option => (option)) 
							}
							break
					}

					/** Verifica se o filtro possui um handler e se seu valor já foi definido no pré-processamento */
					if (filter.handler && filter.params.value) this.call(filter.handler, filter.params.value)

					return filter
				})
			},
			/**
				* Computed property que retorna os dados dos filtros a serem passados
				* para o datatable
				*/
			tableFiltersComputed() {
				return this.filters.map(filter => {
					let params = { ...filter.params }

					if (filter.params.name === 'tags') {
						params.value = this.filterMaker(filter.params.value)
					}

					if (filter.params.name === 'origin_id') {
						params.value = this.filterMaker(filter.params.value, '^', '$')
					}

					if (filter.params.name === 'product_name') {
						params.value = this.filterMaker(filter.params.value, '^', '$')
					}

					if (filter.params.name === 'funnel_stage_status_id') {
						params.value = this.filterMaker(filter.params.value, '^', '$')
					}

					return params
				})
			},

			/**
			 * Computed property que retorna as colunas ativas
			*/
			tableColumnsComputed() {
				return this.tableColumns.filter(column => {
					if (!column.allowedExcept.includes(this.user.user_group)) return column
				})
			},
			/**
				* Computed property que retorna o nome do botão
				* 
				*/
			proposalButtonNameComputed() {
                return this.proposalSettings &&
                    this.proposalSettings.proposal &&
                    this.proposalSettings.proposal.menu_name
                    ? this.proposalSettings.proposal.menu_name
                    : 'Preencher Proposta'
            },
		},

		created: async function () {
			/** Carrega as configurações do formulário */
			await configuration.getConfigurations().then(response => {
				let data = response.data
				for (var prop in data) {
					// eslint-disable-next-line no-prototype-builtins
					if (data.hasOwnProperty(prop)) {
						switch (data[prop].name) {
							case 'dataProposal':
								if (data[prop].value_long) this.$set(this.configurations, 'proposal', data[prop].value_long)
								break
						}
					}
				}
			})

			/** Busca todos as etapas cadastradas no sistema */
			funnel.getStages()
				.then(response => {
					/** Recupera a etapa equivalente à Proposta */
					let stage = Object.values(response.data).find(stage => stage.win_probability === 'proposal')

					/** Caso não exista uma etapa do tipo Proposta, pega a etapa definida nas configurações */
					if (!stage && this.configurations.proposal.stage) {
						stage = { id: this.configurations.proposal.stage }
					}

					if (stage) {
						/** Busca todos os status referentes a etapa de proposta */
						funnel.getStatusByStage(stage.id)
							.then(response => {
								this.configurations.proposal.status = Object.values(response.data)
							})
							.catch(error => {
								if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
							})
					}
				})
				.catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
				})
		},
		

		mounted() {

			/** Redireciona para o guia de cadastro de negócios/clientes do painel Legado */
			this.$root.$on('sales-proposals-add',  () => {
				this.$root.$emit('modal-open-create-deal-modal', 'createProposal', true)
			})

			/** Realiza uma listagem aplicando os filtros necessários */
			this.$root.$on('filter-list-proposals', () => {
				this.$root.$emit('sales-proposals-search')
			})

			/** Trata o evento que limpa os filtros e refaz a listagem */
			this.$root.$on('clear-filters-list-proposals', async () => {
				await this.resetFilters()
				this.$root.$emit('clear-all-dates')
				this.$root.$emit('sales-proposals-search', '', this.filters)
			})

			this.$root.$on('select2-open-event-proposal-list-tags', () => {
				let filter = this.filters.find(item => {
					return item.method == 'getTagOptions'
				})

				if (filter && !filter.requestOnStart && !filter.alreadyRequested) {
					(() => import('@/services/axios/modules/'+ filter.service + '.js'))()
						.then(service => {
							const api = service.default.build()
							let params = ['']

							if (filter.serviceParams) params = [...filter.serviceParams]

							filter.loading = true

							api[filter.method](...params)
							.then(response => {
								let data = []
								/** Verifica se a requisição retornou uma paginação */
								if (Object.prototype.hasOwnProperty.call(response.data, 'total')) {
									data = [...response.data.data]

								/** Verifica se a requisição retornou um array */
								} else if (Object.prototype.hasOwnProperty.call(response.data,'length')) {
									data = [...response.data]

								/** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
								} else if (typeof response.data === 'object') {
									data = { ...response.data }
								}

								/** Verifica se os resultados necessitam ser formatados */
								if (filter.parse) {
									filter.options = filter.parse(data)
								} else {
									filter.options = Object.values(data)
								}

								filter.loading = false
							}).catch(() => {
								filter.loading = false
							})

							filter.alreadyRequested = true
					}).catch(err => {
						console.log(err)
					})
				}
			})
		},

		beforeDestroy() {
			this.$root.$off('sales-proposals-add')
			this.$root.$off('filter-list-proposals')
			this.$root.$off('clear-filters-list-proposals')
			this.$root.$off('select2-open-event-proposal-list-tags')
		},

		methods: {
			/**
				* Chama dinamicamente um handler para tratar o evento do filtro
				*/
			call(handler, event) {
				if (handler) this[handler](event)
			},

			resetFilters() {
				for (const filter of this.filters) {
					filter.params.value = ''
					if (filter.component === 'select-tags') {
						filter.model = []
					}
					
					if (filter.component === 'datepicker-range'){
						filter.params.value = ''
					}
				}
			},
			/**
				* Handler para tratar o evento de quando uma equipe for selecionada, de modo
				* a carregar os gerentes desta equipe
				*/
			teamHandler(value) {
				const manager = this.filters.findIndex(filter => filter.params.name === 'manager_id')
				this.filters[manager].options = []
				this.filters[manager].model   = []

				const broker = this.filters.findIndex(filter => filter.params.name === 'broker_id')
				this.filters[broker].options = []
				this.filters[broker].model 	 = []

				if (value) {
					const managerFilterIndex = this.filters.findIndex(filter => filter.params.name === 'manager_id')
					team.getManagersByTeam(value)
						.then(response => {
							this.filters[managerFilterIndex].options = response.data
							if (['manager', 'broker'].includes(this.user.user_group)) {
								this.call(this.filters[managerFilterIndex].handler, this.filters[managerFilterIndex].params.value)
							}
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
				}
			},

			loadFilters(filters) {
				if (filters) this.filters.map(res => {
                	res.params = filters.find(({ name }) => name == res.params.name)
            	})
				this.loadServices()
			},

			loadServices() {
				for (const filter of this.filters) {
					if (filter.service && filter.requestOnStart && !filter.alreadyRequested) {
						(() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(service => {
							const api = service.default.build()
							let params = ['']
							if (filter.serviceParams) params = [...filter.serviceParams]

							api[filter.method](...params).then(response => {
								let data = []
								/** Verifica se a requisição retornou uma paginação */
									// eslint-disable-next-line no-prototype-builtins
								if (response.data.hasOwnProperty('total')) {
									data = [...response.data.data]

								/** Verifica se a requisição retornou um array */
									// eslint-disable-next-line no-prototype-builtins
								} else if (response.data.hasOwnProperty('length')) {
									data = [...response.data]

								/** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
								} else if (typeof response.data === 'object') {
									data = { ...response.data }
								}

								/** Verifica se os resultados necessitam ser formatados */
								if (filter.parse) {
									filter.options = filter.parse(data)
								} else {
									filter.options = Object.values(data)
								}
							})

							filter.alreadyRequested = true
						})
					}
				}
			},
			/**
				* Handler para tratar o evento de quando um gerente for selecionado, de modo
				* a carregar os corretores pelos quais este é responsável
				*/
			managerHandler(value) {
				const index = this.filters.findIndex(filter => filter.params.name === 'broker_id')
				this.filters[index].options = []
				this.filters[index].model   = []

				if (value) {
					team.getBrokersByManager(value)
						.then(response => {
							const brokerFilterIndex = this.filters.findIndex(filter => filter.params.name === 'broker_id')
							this.filters[brokerFilterIndex].options = response.data
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
				}
			},

			filterMaker(arr, prefix = '', sufix = '') {
				if (!arr) return
				return arr.map(e => `${prefix}${e}${sufix}`).join(',')
			},
			
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>